import {ErrorHandler, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ErrorsHandlerService} from './errors-handler.service';
import {ErrorsInterceptorService} from './errors-interceptor.service';
import {ErrorsServicesModule} from './errors-services.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ErrorsServicesModule
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: ErrorsHandlerService
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorsInterceptorService,
      multi: true
    }
  ]
})
export class ErrorsModule {
}
